import React, { useEffect, useState } from "react";
import "../app/App.css?v=1";
import * as config from "../../config/config";
import axios from "axios";
import { Link } from "react-router-dom";
import { setLocalStore, getLocalStore, convertXxtea, renderDate, cutDate } from "../helpers/helper";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from 'react-router-dom';
import GridLoader from "react-spinners/GridLoader";

export default function HomeAssign() {
    const [listJobs, setListJob] = useState([]);
    const [typeFilter, setTypeFilter] = useState(1); //đã giao
    const [orderDate, setOrderDate] = useState("latest"); // mới nhất
    const [filterBy, setFilterBy] = useState(0); // Tất cả
    const [countJobAssign, setCountJobAssign] = useState(0);
    const [countJobStatus, setCountJobStatus] = useState(0);
    const [displayConfirm, setDisplayConfirm] = useState(false);
    const [displayStatus, setDisplayStatus] = useState(false);
    const [jobIdTarget, setJobIdTarget] = useState(0);
    const [listReceivedJob, setListReceivedJob] = useState([]);
    const [listDoneJob, setListDoneJob] = useState([]);
    const [listOverdueJob, setListOverdueJob] = useState([]);
    const [listWaitingJob, setListWaitingJob] = useState([]);
    const [loading, setLoading] = useState(false);
    const queryParams = new URLSearchParams(window.location.search);
    var uuidParams = queryParams.get("uuid");
    var host = queryParams.get('host');
    if (uuidParams !== null) {
        setLocalStore("uuid", uuidParams);
    } else {
        uuidParams = getLocalStore("uuid");
    }

    if (host !== null) {
        setLocalStore('host', host);
    } else {
        host = getLocalStore('host');
        // host = 'a';
    }

    const navigate = useNavigate();

    useEffect(() => {
        let dataGet = {
            msisdn: uuidParams,
            host: host,
            typeFilter: typeFilter,
            orderDate: orderDate,
            filterBy: filterBy,
            clientType: "web",
            revision: "a",
            languageCode: "vi",
            countryCode: "VN",
            timestamp: new Date().getTime(),
            security: "a",
        };
        // +  qs.stringify(dataGet)

        callApiListJob(dataGet);
    }, []);

    const getDataSort = (event) => {
        let valueSort = event.target.value;
        console.log(valueSort);
        setOrderDate(valueSort);
        renewData(valueSort, filterBy);
    };

    const getDataStatus = (event) => {
        let valueStatus = event.target.value;
        console.log(valueStatus);
        setFilterBy(valueStatus);
        renewData(orderDate, valueStatus);
    };

    function renewData(sort, status) {
        let dataRenew = {
            msisdn: uuidParams,
            host: host,
            typeFilter: typeFilter,
            orderDate: sort,
            filterBy: status,
            clientType: "web",
            revision: "a",
            languageCode: "vi",
            countryCode: "VN",
            timestamp: new Date().getTime(),
            security: "a",
        };

        callApiListJob(dataRenew);
    }

    function callApiListJob(dataRequest) {
        setLoading(true);
        axios({
            method: "POST",
            url: config.DOMAIN_API_JOB_ASSIGN + "filter_job",
            data: dataRequest,
            headers: { "content-type": "multipart/form-data" },
        })
            .then(({ data }) => {
                console.log(data.data);
                setLoading(false);

                if (data.code === 200) {
                    setListJob(data.data);
                    setCountJobAssign(data.data.length);
                    setCountJobStatus(data.data.length);
                } else {
                    console.log(data);
                }
            })
            .catch(function (result) {
                setLoading(false);

                console.log(result);
            });
    }

    function renderDueDate(data) {
        let strDueDate = cutDate(data.jobDueDate);
        if (data.isExpired === 1 && data.jobActive === 0) {
            return (
                <>
                    <img src="./images/icon/date-red.png" alt="dd" />
                    <p className="out-of-date">
                        Thời hạn: <span>{strDueDate}</span>
                    </p>
                </>
            );
        } else {
            return (
                <>
                    <img src="./images/icon/date.png" alt="dd" />
                    <p>
                        Thời hạn: <span>{strDueDate}</span>
                    </p>
                </>
            );
        }
    }

    function renderStatus(data) {
        switch (data.jobState) {
            case 0:
                return <p onClick={() => openStatus(data)} className="notice-not-accepted">Chưa nhận việc ({data.listWaitingJob.length}/{data.listAssignedPerson.length})</p>;
                break;
            case 1:
                return <p onClick={() => openStatus(data)} className="notice-success">Đã hoàn thành ({data.listDoneJob.length}/{data.listAssignedPerson.length})</p>;
                break;
            case 2:
                return <p onClick={() => openStatus(data)} className="notice-out-of-date">Quá hạn ({data.listOverdueJob.length}/{data.listAssignedPerson.length})</p>;
                break;
            case 3:
                return <p onClick={() => openStatus(data)} className="notice-doing">Đang thực hiện ({data.listReceivedJob.length}/{data.listAssignedPerson.length})</p>;
                break;
            default:
        }
    }

    function renderMember(dataMembers) {
        var listMem = [];
        let max = '';
        if (dataMembers.length > 3) {
            max = 3;
        } else {
            max = dataMembers.length;
        }
        for (var i = 0; i < max; i++) {
            listMem.push(dataMembers[i]["name"]);
        }
        var strMems = listMem.join(", ");

        if (max === 3) {
            return <p>{strMems} và {dataMembers.length - max} người khác</p>;
        } else {
            return <p>{strMems}</p>;
        }
    }

    const handleClick = event => {
        event.currentTarget.style = 'display:none';
        console.log('btn click');
    }

    function renderButton(data) {
        if (data.jobActive === 1) {
            return (
                <>
                    <div className="btn-left">
                        <button onClick={() => submitJobs("reopenJob", data.jobAssignId)} > Mở lại </button>
                    </div>
                    <div className="btn-right">
                        <button onClick={() => window.location.assign('vconnect://assignwork?type=create')}> Tạo việc </button>
                    </div>
                </>
            );
        } else {
            if (data.isExpired === 1) {
                return (
                    <>
                        <div className="btn-left">
                            <button onClick={(e) => { submitJobs("closeJob", data.jobAssignId); handleClick(e) }}>  Đóng việc </button>
                        </div>
                        <div className="btn-right">
                            <button onClick={() => submitJobs("remindJob", data.jobAssignId)}>  Nhắc nhở </button>
                        </div>
                    </>
                );
            } else {
                if (data.jobStatus === 0) {
                    return (
                        <>
                            <div className="btn-left">
                                <button onClick={() => openDetailAnDiscuss(data.jobAssignId, data.jobTitle, "discuss", "discuss")} > Thảo luận </button>
                            </div>
                            <div className="btn-right">
                                <button onClick={() => submitJobs("remindJob", data.jobAssignId)}  > Nhắc nhở </button>
                            </div>
                        </>
                    );
                } else {
                    return (
                        <>
                            <div className="btn-left">
                                <button onClick={() => submitJobs("remindJob", data.jobAssignId)} > Nhắc nhở </button>
                            </div>
                            <div className="btn-right">
                                <button onClick={() => openDetailAnDiscuss(data.jobAssignId, data.jobTitle, "discuss", "discuss")} > Thảo luận  </button>
                            </div>
                        </>
                    );
                }
            }
        }
    }

    function submitJobs(action, jobID) {
        setLoading(true);
        console.log(action, jobID);
        let dataJob = {
            action: action,
            phone: uuidParams,
            jobAssignedId: jobID,
        };
        console.log(dataJob);
        let encrypt_data = convertXxtea(dataJob);
        let dataSubmit = {
            msisdn: uuidParams,
            host: host,
            data: encrypt_data,
            clientType: "web",
            revision: "a",
            languageCode: "vi",
            countryCode: "VN",
            timestamp: new Date().getTime(),
            security: "a",
        };

        axios({
            method: "POST",
            url: config.DOMAIN_API_JOB_ASSIGN + "submit_job",
            data: dataSubmit,
            headers: { "content-type": "multipart/form-data" },
        })
            .then(({ data }) => {
                console.log(data);
                if (data.code === 200) {
                    setLoading(false);

                    console.log(action + "success");
                    switch (action) {
                        case "remindJob":
                            toast.success("Đã gửi lời nhắc nhở");
                            break;
                        case "doneJob":
                            toast.success("Đã hoàn thành công việc");
                            break;
                        case "closeJob":
                            toast.success("Đóng việc thành công");
                            break;
                        case "deleteJob":
                            toast.success("Xóa việc thành công");
                            closeConfirm();
                            break;
                        case "recipientJob":
                            toast.success("Nhận việc thành công");
                            break;
                        case "reopenJob":
                            toast.success("Mở lại việc thành công");
                            break;
                        default:
                            toast.success("Success");
                    }
                    if (action !== 'remindJob') {
                        setTimeout(() => {
                            window.location.reload();
                        }, 1000);
                    }

                } else {
                    setLoading(false);

                    console.log(action + "error");
                    switch (action) {
                        case "remindJob":
                            toast.error("Nhắc nhở không thành công");
                            break;
                        case "doneJob":
                            toast.error("Hoàn thành công việc chưa thành công");
                            break;
                        case "closeJob":
                            toast.error("Đóng việc không thành công");
                            break;
                        case "deleteJob":
                            toast.error("Xóa việc không thành công");
                            closeConfirm();
                            break;
                        case "recipientJob":
                            toast.error("Nhận việc không thành công");
                            break;
                        case "reopenJob":
                            toast.error("Mở lại việc không thành công");
                            break;
                        default:
                            toast.error("Error");
                    }
                }
            })
            .catch(function (result) {
                setTimeout(() => {
                    renewData(orderDate, filterBy);
                }, 1000);
                console.log(result);
            });

    }

    function openDetailAnDiscuss(id, title, type, ref) {
        let link =
            "vconnect://assignwork?type=" +
            type +
            "&ref=" +
            encodeURIComponent(config.DOMAIN + "detail?id=" + id) +
            "&title=" +
            encodeURIComponent(title);
        window.location.assign(link);
    }

    function openConfirm(jobId) {
        setDisplayConfirm(true);
        setJobIdTarget(jobId);
    }

    function closeConfirm() {
        setDisplayConfirm(false);
    }

    function openStatus(data) {
        setListReceivedJob(data.listReceivedJob);
        setListWaitingJob(data.listWaitingJob);
        setListDoneJob(data.listDoneJob);
        setListOverdueJob(data.listOverdueJob);
        setDisplayStatus(true);
    }

    function closeStatus() {
        setDisplayStatus(false);
    }

    function renderAvatar(data) {
        if (typeof (data[0]) !== 'undefined' && data[0].avatar !== '') {
            return (
                <img src={data[0].avatar} alt="avt" />
            );
        } else {
            return (
                <img src='../../images/icon/defaultUser.png' alt="avt" />
            );
        }
    }

    function DropdownItem(props) {
        if (props.data.jobActive === 1) {
            return (
                <>
                    <li className="option-item" onClick={() => submitJobs("reopenJob", props.data.jobAssignId)}>
                        Mở lại việc
                    </li>
                    <li className="option-item" onClick={() => openDetailAnDiscuss(props.data.jobAssignId, props.data.jobTitle, "discuss", "discuss")}>
                        Thảo luận
                    </li>
                    <li className="option-item" onClick={() => navigate(`/edit?id=${props.data.jobAssignId}`)}>
                        Chỉnh sửa công việc
                    </li>
                    <li className="option-item" style={{ borderRadius: "0 0 5px 5px" }} onClick={() => openConfirm(props.data.jobAssignId)}>
                        Xóa công việc
                    </li>
                </>
            )
        } else {
            return (
                <>
                    <li className="option-item" onClick={() => submitJobs('remindJob', props.data.jobAssignId)}>
                        Nhắc nhở
                    </li>
                    <li className="option-item" onClick={() => submitJobs("closeJob", props.data.jobAssignId)}>
                        Đóng việc
                    </li>
                    <li className="option-item" onClick={() => openDetailAnDiscuss(props.data.jobAssignId, props.data.jobTitle, "discuss", "discuss")}>
                        Thảo luận
                    </li>
                    <li className="option-item" onClick={() => navigate(`/edit?id=${props.data.jobAssignId}`)}>
                        Chỉnh sửa công việc
                    </li>
                    <li className="option-item" onClick={() => openConfirm(props.data.jobAssignId)}>
                        Xóa công việc
                    </li>
                </>
            )
        }


    }

    return (
        <>
            <Toaster />
            <GridLoader
                color={'#B80001'}
                loading={loading}
                cssOverride={{
                    display: "block",
                    margin: "auto",
                    position: 'absolute',
                    top: '40vh',
                    left: 'calc(50vw - 28px)',
                }}
                height={35}
                size={15}
                width={4}
                radius={2}
                margin={2}
                aria-label="Loading Spinner"
                data-testid="loader"
            />
            <div className="content-tab">
                <Link className="active-tab width100" to="/assign">
                    Đã giao
                </Link>
                <Link className="width100" to="/todo">
                    Cần làm
                </Link>
            </div>
            <div className="content-filter">
                <div className="margin-L15">
                    <p>Bộ lọc</p>
                </div>
                <div className="select-filter">
                    <div className="filter-box">
                        <img src="../../images/icon/sort.png" alt="" />
                        <select name="sort" id="sort" onChange={getDataSort}>
                            <option value="latest">Mới nhất</option>
                            <option value="nearest due">Sắp tới hạn</option>
                            <option value="oldest">Cũ nhất</option>
                        </select>
                    </div>
                    <div className="filter-box">
                        <img src="../../images/icon/status.png" alt="" />
                        <select name="status" id="status" onChange={getDataStatus}>
                            <option value="0">Tất cả trạng thái</option>
                            <option value="2">Đang thực hiện</option>
                            <option value="3">Chưa nhận việc</option>
                            <option value="4">Quá hạn</option>
                            <option value="1">Đã hoàn thành</option>
                        </select>
                        <p>{countJobStatus}</p>
                    </div>
                </div>
            </div>
            <div className="content-assigned">
                {listJobs.length > 0 ? (
                    <>
                        {listJobs.map((item, key) => {
                            return (
                                <div className="task" key={key} >
                                    <div className="task-avatar" onClick={() => openDetailAnDiscuss(item.jobAssignId, item.jobTitle, 'opendetails', 'detail')}>
                                        {renderAvatar(item.listAssignedPerson)}
                                    </div>
                                    <div className="task-content">
                                        <div className="info-box" >
                                            <div className="title">
                                                <p className="title-500" onClick={() => openDetailAnDiscuss(item.jobAssignId, item.jobTitle, 'opendetails', 'detail')}>{item.jobTitle}</p>
                                                {renderStatus(item)}
                                            </div>
                                            <div className="description" >
                                                <p>{item.jobDetails}</p>
                                            </div>
                                            <div className="date" >{renderDueDate(item)}</div>
                                            <div className="members" >
                                                <img src="./images/icon/bag.png" alt="" />
                                                {renderMember(item.listAssignedPerson)}
                                            </div>
                                        </div>
                                        <div className="button-task">
                                            {renderButton(item)}
                                        </div>
                                    </div>
                                    <div className="task-option">
                                        <div className="dropdown-container">
                                            <div className="three-dots" tabIndex="-1"></div>
                                            <ul className="dropdown">
                                                <DropdownItem data={item} />
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </>
                ) : (
                    <>
                        <div className="nodata">
                            <img src="../../images/icon/no-assign.png" alt="" />
                            <p>Chà, dường như bạn chưa giao công việc nào cả. Sao không thử ngay hôm nay?</p>
                            <button onClick={() => window.location.assign('vconnect://assignwork?type=create')}>Tạo công việc mới ngay</button>
                        </div>
                    </>
                )}
            </div>

            {displayConfirm &&
                <div className="confirm-container" onClick={() => closeConfirm()}>
                    <div className="confirm-box">
                        <div className="confirm-title">
                            <p>Xóa công việc</p>
                        </div>
                        <div className="confirm-content">
                            <p>Công việc này sẽ được xóa hoàn toàn và không thể khôi phục. Bạn vẫn muốn xóa?</p>
                        </div>
                        <div className="confirm-btn">
                            <div className="btn-cancel">
                                <button onClick={() => closeConfirm()} >Không xóa</button>
                            </div>
                            <div className="btn-accept">
                                <button onClick={() => submitJobs('deleteJob', jobIdTarget)}>Xóa công việc</button>
                            </div>
                        </div>
                    </div>
                </div>}
            {displayStatus
                &&
                <div className="statusDetail-container" onClick={() => closeStatus()}>
                    <div className="status-box">
                        <div className="nav-box">
                            <p className="title">Chi tiết trạng thái công việc</p>
                            <img onClick={() => closeStatus()} src="../../images/icon/x-button.png" alt="" />
                        </div>
                        <div className="status-info">

                            {listDoneJob.length > 0 && (
                                <div className="done">
                                    <p className="title" style={{ color: "#007934" }}>Hoàn thành:</p>
                                    <div className="status-list">
                                        {listDoneJob.map((item, key) => {
                                            return (
                                                <div className="item-status" key={key}>
                                                    <img src='../../images/icon/defaultUser.png' alt="avt" />
                                                    <p className="userName">{item.name}</p>
                                                </div>
                                            );
                                        })}

                                    </div>
                                </div>
                            )}

                            {listReceivedJob.length > 0 && (
                                <div className="receipt">
                                    <p className="title" style={{ color: "#5297FE" }}>Đã nhận:</p>
                                    <div className="status-list">
                                        {listReceivedJob.map((item, key) => {
                                            return (
                                                <div className="item-status" key={key}>
                                                    <img src='../../images/icon/defaultUser.png' alt="avt" />
                                                    <p className="userName">{item.name}</p>
                                                </div>
                                            );
                                        })}

                                    </div>
                                </div>
                            )}

                            {listWaitingJob.length > 0 && (
                                <div className="waiting">
                                    <p className="title" >Chưa nhận:</p>
                                    <div className="status-list">
                                        {listWaitingJob.map((item, key) => {
                                            return (
                                                <div className="item-status" key={key}>
                                                    <img src='../../images/icon/defaultUser.png' alt="avt" />
                                                    <p className="userName">{item.name}</p>
                                                </div>
                                            );
                                        })}

                                    </div>
                                </div>
                            )}

                            {listOverdueJob.length > 0 && (
                                <div className="out-of-date">
                                    <p className="title" style={{ color: "#B80001" }}>Quá hạn:</p>
                                    <div className="status-list">
                                        {listOverdueJob.map((item, key) => {
                                            return (
                                                <div className="item-status" key={key}>
                                                    <img src='../../images/icon/defaultUser.png' alt="avt" />
                                                    <p className="userName">{item.name}</p>
                                                </div>
                                            );
                                        })}

                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            }
        </>
    );
}
